import { createDirective } from 'v-mask/src/directive';

export const AbcMaskDirective = createDirective;
